module.exports = __webpack_public_path__ + "static/media/ic_stop_share_my_location.a953d5c5.svg";